module.exports = __webpack_public_path__ + "img/product_95.812ba90.webp";